module.exports = __webpack_public_path__ + "assets/images/project/ndp-tag-logo.png?v=7e69fff3";